/* storefrontContent.js — helper murni untuk konten storefront tenant
   (settings.branding.storefront). Tanpa React agar mudah di-unit-test. */

export const isTruthyFlag = (v) => ["true", "1", "yes", true].includes(typeof v === "string" ? v.trim().toLowerCase() : v);

export const isExternalUrl = (url) => /^(https?:)?\/\//i.test(String(url || "").trim()) || /^(mailto|tel):/i.test(String(url || "").trim());

/* Fallback NETRAL — hanya dipakai bila tenant mengaktifkan CTA tanpa mengisi teks.
   Tidak boleh mengandung istilah industri tertentu. */
export const CTA_FALLBACK = Object.freeze({
  badge: "PENAWARAN KHUSUS",
  title: "Butuh Penawaran Khusus?",
  description: "Hubungi kami untuk mendapatkan informasi dan penawaran sesuai kebutuhan Anda.",
  button_text: "Hubungi Kami",
});

const clean = (v) => String(v ?? "").trim();

/**
 * Resolve konten Business CTA dari branding tenant.
 * @returns {null | {badge, title, description, buttonText, href, external, backgroundStyle, backgroundImage}}
 *   null = CTA nonaktif (tidak dirender).
 */
export function resolveBusinessCta(branding) {
  const sf = (branding && branding.storefront) || {};
  if (!isTruthyFlag(sf.cta_enabled)) return null;
  const contact = (branding && branding.contact) || {};
  const action = clean(sf.cta_button_action).toLowerCase() || (contact.whatsapp ? "whatsapp" : "link");
  const url = clean(sf.cta_button_url);
  const title = clean(sf.cta_title) || CTA_FALLBACK.title;
  const buttonText = clean(sf.cta_button_text) || CTA_FALLBACK.button_text;

  let href = "";
  if (action === "whatsapp" && contact.whatsapp) {
    href = `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(`Halo, saya ingin bertanya tentang "${title}".`)}`;
  } else if (url) {
    href = url;
  } else if (contact.whatsapp) {
    href = `https://wa.me/${contact.whatsapp}`;
  } else if (contact.email) {
    href = `mailto:${contact.email}`;
  }
  if (!href) return null; // tidak ada tujuan valid → jangan render tombol mati

  const bgStyle = ["soft", "solid", "image"].includes(clean(sf.cta_background_style)) ? clean(sf.cta_background_style) : "soft";
  const backgroundImage = bgStyle === "image" ? clean(sf.cta_background_image) : "";
  return {
    badge: clean(sf.cta_badge) || CTA_FALLBACK.badge,
    title,
    description: clean(sf.cta_description) || CTA_FALLBACK.description,
    buttonText,
    href,
    external: isExternalUrl(href),
    backgroundStyle: backgroundImage ? "image" : (bgStyle === "image" ? "soft" : bgStyle),
    backgroundImage,
  };
}
